<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [(ngModel)]="months" placeholder="Seleccionar Mes" (select)="changeMonthsAgo($event)">
    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>
</ngx-select>